module.exports = __webpack_public_path__ + "static/ostrava-2026-8ea722c0176749d82037d421784aced5.jpg";